export namespace Constants {
  export const sessionIdHeaderName: string = 'X-UserSessionId'

  export const protocolAndHostName: string = `https://${window.location.hostname}`

  export const stickyNotesOndcAppIdForOneNoteApi = 'StickyNotesONDCIntegration'
  export const stickyNotesOndcAppIdForLogging = 'StickyNotes_Web' // This is used for our GDPR export pipeline

  export const sdkTelemetryEventName = 'SDKTelemetryEvent'

  // These variables need to be kept in sync with
  // https://github.com/microsoft-notes/api/wiki/Client-Onboarding-Info
  export const notesFabricApiCreatedByApp = 'OneNote'

  export const outlookO365ResourceUri = 'https://outlook.office365.com'

  // NotesBeta constants
  export const WELL_KNOWN_MICROSOFT_TENANT_ID = '72f988bf-86f1-41af-91ab-2d7cd011db47'

  export const WELL_KNOWN_LOCALHOST_TENANT_ID = '2f6dd297-219b-4389-ad1c-33760bc2fe4c'

  // TODO(alkwa): please remove this after we leave MSIT dogfood and redirect towards an area where we want to collect feedback
  // tslint:disable-next-line:max-line-length
  export const DOGFOOD_TEAMS_CHAT = 'https://teams.microsoft.com/l/channel/19%3a4dcda2a3adf34b86a798da2602969847%40thread.skype/Sticky%2520Notes%2520in%2520OneNote%2520Online?groupId=8b8d22c3-6f9e-4c9a-9d3e-cf756a15d7e3&tenantId=72f988bf-86f1-41af-91ab-2d7cd011db47'

  export const MSA_T1_EXPORT_LINK = 'https://go.microsoft.com/fwlink/?linkid=2009717'

  export const cancelledError = 'CANCELLED'

  export const EDGE_HUB_QUERY_FIELD = 'isEdgeHub'

  export const SERVICE_WORKER_QUERY_FIELD = 'isSw'

  export const AUTH_QUERY_FIELD = 'auth'

  export const HOST_APP_TYPES = {
    EDGE_HUB: 'EdgeHub',
    WEB_APP: 'Hub',
  }

  export const RING_TYPE = {
    INTERNAL: 'internal',
    PRODUCTION: 'production',
  }

  export const NEW_USER_TO_ON_ECOSYSTEM_TELEMETRY_FLUSH_EVENT = 'flushNewUserTelemetry'

  export const LOCAL_STORAGE_KEY_FOR_SHORELINE_FEED_USER= 'isShoreLineFeedUser'
}
